@if (showDialog()) {
  @let item = current();
  <kendo-dialog
    width="50%"
    (close)="onClose()"
    #dialog="kendoDialog"
    id="announcementPopup"
  >
    <kendo-dialog-titlebar>
      <div class="container-fluid">
        <div class="row">
          <div class="col text-center">
            {{ item.headerText }}
          </div>
        </div>
      </div>
    </kendo-dialog-titlebar>
    <div class="release-body">
      <div class="row">
        <div class="col" [innerHTML]="safeShortDescription()"></div>
      </div>
      <div class="row">
        <div class="col d-flex">
          @for (link of documentLinks(); track link.file) {
            <a
              class="file btn btn-outline-primary"
              target="_blank"
              [href]="link.url"
            >
              <i class="fas fa-file"></i>
              <span class="d-block">{{ link.file.description }}</span>
            </a>
          }
        </div>
      </div>
      @if (item.longContent && item.longContent.length > 0) {
        <div class="row see-details d-flex" (click)="toggleDetails()">
          <div class="left-icon">
            <i class="fas fa-chevron-{{ showDetails() ? 'up' : 'down' }}"></i>
          </div>
          <div class="line"></div>
          <div class="verbiage">
            {{ showDetails() ? 'Hide Details' : 'See Details' }}
          </div>
          <div class="line"></div>
          <div class="right-icon">
            <i class="fas fa-chevron-{{ showDetails() ? 'up' : 'down' }}"></i>
          </div>
        </div>
      }
      <div
        class="details"
        [ngClass]="{ collapsed: !showDetails() }"
        [innerHTML]="item.longContent"
      ></div>
    </div>
    <div
      class="arrows-container d-flex align-items-center justify-content-between"
    >
      @if (visibleIdx() > 0) {
        <div class="left-arrow me-auto" (click)="previousAnnouncement()">
          <div class="fa-stack fa-2x">
            <i class="fas fa-stop fa-stack-2x"></i>
            <i class="fas fa-angle-double-left fa-inverse fa-stack-1x"></i>
          </div>
        </div>
      }
      @if (announcements().length > visibleIdx() + 1) {
        <div class="right-arrow ms-auto" (click)="nextAnnouncement()">
          <div class="fa-stack fa-2x">
            <i class="fas fa-stop fa-stack-2x"></i>
            <i class="fas fa-angle-double-right fa-inverse fa-stack-1x"></i>
            @if (unseenAnnouncement()) {
              <i
                class="fas fa-circle fa-inverse fa-stack-1x unseen-indicator"
              ></i>
            }
          </div>
        </div>
      }
    </div>
  </kendo-dialog>
}
